module.exports = __webpack_public_path__ + "static/tree_branches_albedo-51ea403a7ba1c5c08c62614770dcc991.png";